const Menu = [
  {
    path: "/dashboard-panels",
    icon: "fa fa-chart-simple",
    title: "Dashboard Panels",
    requiredPermissions: ['dashboard'],
    children: [
      {
        path: "/dashboard-panels/dashboard",
        title: "Congestion Dashboard",
      },
    ],
  },
  {
    path: "/model-mapping-panels",
    icon: "fa fa-layer-group",
    title: "Modelling Panels",
    requiredPermissions: ['model-mapping'],
    children: [
      {
        path: "/model-mapping-panels/model-mapping/",
        title: "Model Mapping",
      },
    ],
  },
  {
    path: "/evacuation-portal-panels",
    icon: "fa fa-route",
    title: "Evacuation Portal Panels",
    requiredPermissions: ['evacuation-portal'],
    children: [
      {
        path: "/evacuation-portal-panels/evacuation-portal/",
        title: "Evacuation Zone Map",
      },
      {
        path: "/evacuation-portal-panels/evacuation-order-report/",
        title: "Evacuation Order Report",
      },
      {
        path: "/evacuation-portal-panels/evacuation-events",
        title: "Evacuation Events Table",
      },
      {
        path: "/evacuation-portal-panels/evacuation-orders",
        title: "Evacuation Orders Table",
      },
      { 
        path: "/evacuation-portal-panels/evacuation-dashboard",
        title: "Evacuation Dashboard",
      },
      
      {
        path: "/evacuation-portal-panels/evacuation-settings",
        title: "Evacuation Settings",
      },
    ],
  },
  {
    path: "/congestion-panels",
    icon: "fa fa-road",
    title: "Congestion Panels",
    requiredPermissions: ['congestion'],
    children: [
      {
        path: "https://acuere.ca/webservices/traffica/rdco/ci.asp",
        title: "Congestion Map",
        target: "_blank",
      },
      {
        path: "https://acuere.ca/webservices/traffica/rdco/ci-metrics.asp",
        title: "Congestion Map Metrics",
        target: "_blank",
      },
      {
        path: "https://acuere.ca/webservices/traffica/rdco/ci-diff.asp",
        title: "Congestion Map-Diff",
        target: "_blank",
      },
      {
        path: "https://acuere.ca/webservices/traffica/kelowna/vtmc.asp",
        title: "vTMC",
        target: "_blank",
      },
      {
        path: "https://acuere.ca/webservices/traffica/kelowna/report.asp",
        title: "Report/Export Module",
        target: "_blank",
      },
    ],
  },
  {
    path: "/documentation",
    icon: "fa fa-book",
    title: "Documentation",
    requiredPermissions: ['documentation'],
    children: [
      {
        path: "/documentation/dashboard-documentation",
        title: "Dashboard Panels Documentation",
        requiredPermissions: ['documentation-dashboard'],
        target: "_blank",
      },
      {
        path: "/documentation/modelling-documentation",
        title: "Modelling Panels Documentation",
        requiredPermissions: ['documentation-modelling'],
        target: "_blank",
      },
      {
        path: "/documentation/evacuation-documentation",
        title: "Evacuation Panels Documentation",
        requiredPermissions: ['documentation-evacuation'],
        target: "_blank",
      },
    ],
  },
  {
    path: "/resources-links",
    icon: "fa fa-up-right-from-square",
    title: "Resources and Links",
    requiredPermissions: ['resources-links'],
  },
  {
    path: "/contacts",
    icon: "fa fa-address-book",
    title: "Contacts",
    requiredPermissions: ['contacts'],
  },
];

export default Menu;
